module.exports = __webpack_public_path__ + "static/media/theoryQ1.314fe3ad.png";